export const appointmentQueryKeys = [
  'appointment-events',
  'overview-appointments',
  'appointment-queue',
  'patient-appointments'
];

export const clinicalNotesQueryKeys = [
  'clinicalNotes',
  'overview-clinical-notes',
  'clinicalNotesInfinite',
  'checkPatientNotes'
];

export const overviewLedgerQueryKeys = ['overview-ledger', 'overview-balance-ledger'];
